import "./index.css";
import { cn } from "utils";

const NumericCircle = ({ className, isActive, value, dataTestId }) => {
  return (
    <span
      data-testid={dataTestId}
      className={cn(
        "bg-gray-200 numberCircle",
        {
          "text-white !bg-sky-600": isActive,
        },
        className
      )}
    >
      <span> {value}</span>
    </span>
  );
};

export default NumericCircle;
